import {BaseUtils} from "./base-utils";

export class CookieUtils extends BaseUtils {

  static injectables = [];

  getCookieByName(cookieName) {
    const nameEQ = cookieName + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  setCookie(name, value, expireDays, crossDomain = false) {
    const d = new Date();
    const domain = crossDomain ? '365scores.com' : window.location.host;
    d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=." + domain;
  }

  getCookiesBySubstring(substring) {
    const ca = document.cookie.split(';');
    const cookieDict = ca.map(item => item.split(/=(.*)/).filter(cell => cell !== ''))
    const caFiltered = cookieDict.filter(item => item[0]?.includes(substring))

    return caFiltered;
  }
}
